import { Slot } from '@radix-ui/react-slot';

import { cn } from '@/utils/cn';
import Text from '@/components/ui/Text';

export const buttonBase =
  'rounded-xs inline-flex items-center justify-center transition-all duration-300 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none cursor-pointer';

export const buttonVariants = {
  primary:
    'px-btn-x py-btn-y min-h-btn bg-primary text-white hover:bg-primary/90',
  secondary:
    'px-btn-x py-btn-y min-h-btn bg-secondary text-white hover:bg-secondary/90',
  ghost:
    'px-btn-x py-btn-y min-h-btn text-primary hover:bg-primary hover:text-white border-2 border-primary',
  text: 'text-primary hover:text-primary/70 justify-start',
};

const Button = ({
  variant = 'ghost',
  textVariant = 'ctaButton',
  arrow = false,
  asChild = false,
  className,
  children,
  ...rest
}: ButtonProps) => {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp
      className={cn(buttonBase, buttonVariants[variant], className)}
      {...rest}
    >
      <Text as="span" variant={textVariant}>
        {children}
        {arrow && <Arrow />}
      </Text>
    </Comp>
  );
};

export default Button;

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'text';
type ButtonTextVariant = 'ctaButton' | 'submitButton';

type ButtonProps = {
  variant?: ButtonVariant;
  textVariant?: ButtonTextVariant;
  arrow?: boolean;
  asChild?: boolean;
  className?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Arrow = () => (
  <span aria-hidden="true" className="pl-2">
    →
  </span>
);
